import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Elmarknaden = lazy(() => import("@/pages/elmarknaden/Elmarknaden"));

export const Route = createFileRoute("/elmarknaden/")({
  head: () => seoHead("/elmarknaden", { description: "Sveriges elmarknad är en av Europas mest förnybara – och en av de mest komplexa. Här förklarar vi hur den fungerar, hur den har vuxit fram och vart den är på väg." }),
  component: () => <Elmarknaden />,
});
